import parkImage from "../assets/images/amusement-park.png";
import ticketIcon from "../assets/icons/coupon-2-line-2.png";

export default function MyBookings() {
  const tickets = [
    {
      id: 1,
      date: "16 Feb 2021",
      title: "Jamuna Amusement Park",
      address:
        "Independent University, Bangladesh, Plot 16 Aftab Uddin Ahmed Rd · Dhaka",
      entry: "3 Entry Tickets",
      ride: "12 Ride Tickets",
      status: "Expired",
      price: "300৳",
      purchaseId: "PRK300123457891",
      image: parkImage,
    },
    {
      id: 2,
      date: "16 Feb 2021",
      title: "Jamuna Amusement Park",
      address:
        "Independent University, Bangladesh, Plot 16 Aftab Uddin Ahmed Rd · Dhaka",
      entry: "3 Entry Tickets",
      ride: "12 Ride Tickets",
      status: "Canceled",
      price: "300৳",
      purchaseId: "PRK300123457891",
      image: parkImage,
    },
  ];

  return (
    <div className="container-fluid bg-light min-vh-100 p-4">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-3 mb-4">
          <div className="list-group rounded">
            <a
              href="/"
              className="list-group-item list-group-item-action border-0"
            >
              <i className="fa-regular fa-user me-2" />
              My Profile
            </a>
            <a
              href="/"
              className="list-group-item list-group-item-action border-0 text-success fw-semibold"
            >
              <i className="fa-regular fa-bookmark me-2" />
              My Bookings
            </a>
            <a
              href="/"
              className="list-group-item list-group-item-action border-0"
            >
              <i className="fa-solid fa-users me-2" />
              My Family & Friends
            </a>
          </div>
        </div>

        {/* Content */}
        <div className="col-md-9">
          <h4 className="fw-semibold mb-3">My tickets</h4>

          {/* Tabs */}
          <ul className="nav nav-tabs mb-4 border-0">
            <div className="nav-link border-0 border-bottom text-secondary">
              Active
            </div>
            <div className="nav-link border-0 border-bottom text-secondary">
              Completed
            </div>
            <div className="nav-link border-0 border-bottom text-secondary text-success fw-semibold border-success">
              Expired
            </div>
          </ul>

          {/* Tickets */}
          {tickets.map((ticket) => (
            <div className="card mb-4 shadow-sm" key={ticket.id}>
              <div className="d-none d-sm-flex justify-content-between border-bottom px-3 py-2">
                <small className="text-muted">
                  <i className="fa-solid fa-clock" /> {ticket.date}
                </small>
                <small className="text-muted">
                  Purchase ID: <b>{ticket.purchaseId}</b>
                </small>
              </div>
              <div className="row g-0 align-items-center">
                <div className="col-md-2 text-center px-0 px-sm-2">
                  <img
                    src={ticket.image}
                    alt="park-image"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="col-md-7 p-3">
                  <h5 className="fw-bold mb-3">{ticket.title}</h5>
                  <p className="mb-1 text-muted small mb-3">
                    <i className="fa-solid fa-location-dot text-success me-2" />
                    {ticket.address}
                  </p>
                  <div className="mt-2">
                    <img
                      className="me-1"
                      height={13}
                      src={ticketIcon}
                      alt="ticket icon"
                    />
                    <small>Tickets</small>
                  </div>
                  <div className="text-muted small mb-2">
                    <div className="d-flex justify-content-between">
                      <div>{ticket.entry}</div>
                      <div className="text-danger fw-semibold">
                        {ticket.status}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>{ticket.ride}</div>
                      <div className="text-danger fw-semibold">
                        {ticket.status}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 text-end pe-3 pb-3">
                  <h5 className="text-success fw-bold mb-2">{ticket.price}</h5>
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm"
                  >
                    VIEW DETAILS
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
